import type {FC} from 'react';
import clsx from 'clsx';

import {ContentBlockHeading} from '@/modules/foundation/components/content-block-heading';
import type {KeyedArray} from '@/modules/foundation/shared/types';
import {
	ContentBlockContainer,
	type ContentBlockContainerProps,
} from '@/modules/page/components/content-blocks/block-container';

import type {Person} from '../../shared/types';
import {PersonCard} from '../person-card';

interface Props extends ContentBlockContainerProps {
	people: KeyedArray<Person>;
	heading?: string;
	anchorHeading?: boolean;
	insideToc?: boolean;
}

const PersonList: FC<Props> = ({people, heading, anchorHeading, options, insideToc}) => {
	return (
		<ContentBlockContainer options={options} insideToc={insideToc}>
			<ContentBlockHeading heading={heading} anchorHeading={anchorHeading} />

			<ul className={clsx('flex', 'flex-wrap', 'gap-4')}>
				{people.map((person) => {
					return (
						<li key={person._key}>
							<PersonCard person={person} />
						</li>
					);
				})}
			</ul>
		</ContentBlockContainer>
	);
};

export default PersonList;
